import {Injectable} from '@angular/core';
import {NgEventBus} from 'ng-event-bus';
import {SpatialUtilService} from '../../../../services/spatial-util.service';
import {AnnotationService} from '../../../../services/features/annotation.service';
import {WidgetService} from '../../../../services/widget.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class AnnotationEditorToolService {
    private readonly title = 'AnnotationEditorToolService';

    private graphicFeatures: any[];

    private tool: any;

    private attributes: any;

    constructor(
        private annotationService: AnnotationService,
        private eventBus: NgEventBus,
        private spatialUtilService: SpatialUtilService,
        private widgetService: WidgetService
    ) {}

    setupFeatureEventModification(tool: any, attributes: any) {
        console.debug(`${this.title} - setupFeatureEventModification`);

        this.tool = tool;
        this.attributes = attributes;
    }

    create(attributes: any, features: any[]) {
        console.debug(`${this.title} - create`);

        this.attributes = attributes;

        this.graphicFeatures = [...features].sort((a, b) => b.attributes.id - a.attributes.id);

        this.graphicFeatures.forEach((feature, featureIndex: number) => {
            for (const [attributeKey, attributeValue] of Object.entries(this.attributes) as any[]) {
                if (
                    this.graphicFeatures.length === 1 ||
                    (`attribute${featureIndex + 1}` === attributeKey && Object.hasOwn(feature.attributes, attributeKey))
                ) {
                    feature.attributes[attributeKey] = attributeValue;
                }
            }
        });

        features.forEach((feature: {attributes: {id?: any; parentid?: any}}) => {
            const allAnnotations = this.spatialUtilService.getAnnotations();
            allAnnotations.forEach((annotation: {attributes: {id?: any; parentid?: any}}) => {
                if (feature.attributes.id === annotation.attributes.parentid) {
                    this.copyAttributes(feature, annotation);
                    this.graphicFeatures.push(annotation);
                    this.findAndUpdateRelatedAnnotations(allAnnotations, feature, this.graphicFeatures, annotation.attributes.parentid);
                }

                if (feature.attributes.parentid === annotation.attributes.id) {
                    this.copyAttributes(feature, annotation);
                    this.graphicFeatures.push(annotation);
                    this.findAndUpdateRelatedAnnotations(allAnnotations, feature, this.graphicFeatures, annotation.attributes.id);
                }
            });

            this.annotationService.updateAnnotations(this.graphicFeatures).subscribe(() => {
                // This is a work around for now but graphicToModify has to be gone. DIEGO please restructure it
                this.eventBus.cast('updateGraphicToModify', this.graphicFeatures[this.graphicFeatures.length - 1]);

                this.removeSelectedAnnotationGraphics();

                this.eventBus.cast('resetMapClickHandler');

                window.setTimeout(() => {
                    if (this.widgetService.isWidgetActive('IdentifyFeatures')) {
                        this.eventBus.cast('resetFeaturesInteracted');
                    }
                }, 100);
            });
        });
    }

    private findAndUpdateRelatedAnnotations(features: any[], fromFeature: any, annotations: any[], parentId: any) {
        features.forEach((feature: {attributes: {parentid?: any}}) => {
            if (feature.attributes.parentid === parentId) {
                this.copyAttributes(fromFeature, feature);
                annotations.push(feature);
            }
        });
    }

    private copyAttributes(fromFeature: any, toFeature: any) {
        for (let i = 1; i <= 10; i++) {
            const key = `attribute${i}`;
            if (fromFeature.attributes[key] && toFeature.attributes[key]) {
                toFeature.attributes[key] = fromFeature.attributes[key];
            }
        }
    }

    private removeSelectedAnnotationGraphics() {
        console.debug(`${this.title} - removeSelectedAnnotationGraphics`);

        const annotationsToBeRemoved = this.graphicFeatures.filter(
            (feature: any) => feature.attributes.labelexpression === undefined || feature.attributes.labelexpression === null
        );

        if (annotationsToBeRemoved.length > 0) {
            this.spatialUtilService.unhighlightFeatures('annotation', annotationsToBeRemoved);
        }
    }
}
